import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "menu" }
const _hoisted_2 = {
  key: 0,
  class: "menu-content"
}
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "menu-content" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "menu-content" }

import { computed, ref, watch } from "vue";
import { svgIcon } from "@/common/components";
// types
import type { ReportType, ReportBlockType } from "@/common/types/report";
// editors
import BlockEditor from "./editors/block-editor.vue";
import EmptyEditor from "./editors/empty.vue";
import MenuEditor from "./editors/menu.vue";
import TextEditor from "./editors/text-editor.vue";
import TableEditor from "./editors/table-editor.vue";

interface MenusType {
  title: string;
  component: any;
  props: Record<string, any>;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'menu',
  props: {
    type: {},
    block: {},
    report: {}
  },
  emits: [
  "close",
  "block:add",
  "block:update",
  "report:reload",
  "report:update",
  "select:type",
  "page:add",
],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const internalType = ref(props.type || "empty");

const menus = computed(() => ({
  empty: {
    title: "Empty",
    component: EmptyEditor,
    props: {
      report: props.report,
    },
  },
  add: {
    title: "Adicionar Bloco",
    component: MenuEditor,
    props: {
      block: props.block,
    },
  },
  "block-text": {
    title: "Editar Texto",
    component: TextEditor,
    props: {
      block: props.block,
    },
  },
  "block-title": {
    title: "Editar Título",
    component: TextEditor,
    props: {
      block: props.block,
    },
  },
  "block-table": {
    title: "Editar Tabela",
    component: TableEditor,
    props: {
      block: props.block,
      report: props.report,
    },
  },
  "block-data": {
    title: "Editar Bloco",
    component: BlockEditor,
    props: {
      block: props.block,
      report: props.report,
    },
  },
}));

const selectedMenu = computed<MenusType | null>(
  () => menus.value[internalType.value as never],
);

function blockAdd(type: string) {
  emit("block:add", type);
}

function blockUpdate(block: ReportBlockType) {
  emit("block:update", block);
}

function clickEmptyMenu(key: "add" | "page") {
  if (key === "add") {
    emit("select:type", key);
    return;
  }

  if (key === "page") {
    emit("page:add");
    return;
  }

  emit("select:type", key);
}

watch(
  () => props.type,
  (value) => {
    internalType.value = value || "empty";
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (internalType.value === 'empty')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(menus.value.empty.component), _mergeProps(menus.value.empty.props, {
            "onClick:menu": clickEmptyMenu,
            "onReport:update": _cache[0] || (_cache[0] = ($event: any) => (emit('report:update', $event))),
            "onReport:reload": _cache[1] || (_cache[1] = ($event: any) => (emit('report:reload')))
          }), null, 16))
        ]))
      : (internalType.value === 'add')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_3, [
              _createTextVNode(_toDisplayString(menus.value[internalType.value].title) + " ", 1),
              _createElementVNode("button", {
                class: "close-button",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('close')))
              }, [
                _createVNode(_unref(svgIcon), {
                  icon: "close",
                  size: "1.25rem"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(menus.value[internalType.value].component), {
                "internalBlock.value.content.table": "",
                "onBlock:add": blockAdd
              }, null, 32))
            ])
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            (selectedMenu.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_5, [
                    _createTextVNode(_toDisplayString(selectedMenu.value!.title) + " ", 1),
                    _createElementVNode("button", {
                      class: "close-button",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (emit('close')))
                    }, [
                      _createVNode(_unref(svgIcon), {
                        icon: "close",
                        size: "1.25rem"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(selectedMenu.value!.component), _mergeProps(selectedMenu.value!.props, { "onBlock:update": blockUpdate }), null, 16))
                  ])
                ], 64))
              : _createCommentVNode("", true)
          ], 64))
  ]))
}
}

})